<template>
  <v-container v-if="nodeData" fluid>
    <node-editor
      v-if="adding"
      :meta="addClassMeta"
      :readonly="false"
      :parent-node-id="id"
      :parent-class-id="nodeData.cid || 0"
      :can-sort="canSortInThis"
      auto-height
      @editor-close="goThis"
      @apply="goThis"
    />
    <node-children
      v-else-if="canHaveChildren && isChildrenView"
      :node-id="id"
      :meta="meta"
      :can-sort="canSortInParent"
    />
    <node-editor
      v-else
      :meta="meta"
      :readonly="!$canEdit()"
      :node-id="id"
      :parent-class-id="nodeData.pcid || 0"
      :can-sort="canSortInParent"
      auto-height
      :can-close="!isParentRoot"
      @editor-close="goParent"
      @apply="goParent"
    />
  </v-container>
</template>

<script>
import NodeEditor from "./NodeEditor.vue";
import NodeChildren from "./NodeChildren.vue";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
export default {
  name: "Node",
  components: {
    NodeEditor,
    NodeChildren
  },
  mixins: [CheckPermissionMixin],
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    classAdd: {
      type: [String, Number],
      default: null
    },
    pid: {
      type: [String, Number],
      default: null
    }
  },
  data: () => ({}),
  computed: {
    adding() {
      return this.classAdd !== null;
    },
    isChildrenView() {
      return this.$route.name && this.$route.name == "NodeChildren";
    },
    addClassMeta() {
      return this.$store.getters.getMeta(this.classAdd);
    },
    nodeData() {
      return this.$store.getters.getCurrentNode(this.id);
    },
    meta() {
      return this.$store.getters.getMeta(this.nodeData?.cid || 0);
    },
    canHaveChildren() {
      return this.meta.children.length > 0;
    },
    isParentRoot() {
      return this.nodeData?.cid == this.nodeData?.ac;
    },
    canSortInThis() {
      const classThis = this.$store.getters.getMetaClass(
        this.nodeData.cid || 0
      );
      return classThis.can_sort_children == 1;
    },
    canSortInParent() {
      if (this.isParentRoot) return false;
      const classParent = this.$store.getters.getMetaClass(this.nodeData.pcid);
      return classParent.can_sort_children == 1;
    }
  },
  mounted() {
    this.$store.dispatch("fetchCurrentNode", this.id);
  },
  methods: {
    goThis() {
      const { id } = this;
      this.$router.push({ name: "NodeChildren", params: { id } });
    },
    goParent() {
      if (this.isParentRoot) return;
      if (this.pid) {
        this.$router.push({ name: "NodeChildren", params: { id: this.pid } });
      } else {
        const id = this.nodeData.pid;
        this.$router.push({ name: "NodeChildren", params: { id } });
      }
    }
  }
};
</script>
